module.exports = __webpack_public_path__ + "static/img/pic_bg.7fd8fa8b.png";